import { useLang } from '../i18n';

export function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-white">
      <div className="flex items-center justify-center px-4 pt-14">
        <a
          href="https://www.instagram.com/vizio.mp3"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-link-contacts"
          className="link-underline font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-700"
        >
          {t('footer.contact')}
        </a>
      </div>

      <div
        data-testid="footer-legal"
        className="mt-8 flex flex-col items-center gap-1.5 px-6 text-center font-mono text-[9px] uppercase leading-relaxed tracking-[0.2em] text-neutral-500"
      >
        <p data-testid="footer-legal-name" className="text-neutral-700">
          Mennella Antonio
        </p>
        <p>Via Duca Lecco De Guevara, 17</p>
        <p>Torre del Greco — Napoli</p>
        <p data-testid="footer-vat">P.IVA 11094341218</p>
        <div className="mt-4 flex items-center gap-8">
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            data-testid="footer-link-privacy"
            className="link-underline text-neutral-700"
          >
            {t('footer.privacy')}
          </a>
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            data-testid="footer-link-cookie"
            className="link-underline text-neutral-700"
          >
            {t('footer.cookie')}
          </a>
        </div>
      </div>

      <div className="mt-10 overflow-hidden px-6">
        <img
          src="/assets/wordmark-chrome.png"
          alt="VIZIO"
          data-testid="footer-wordmark"
          className="mx-auto w-full max-w-3xl translate-y-[22%] select-none"
          draggable="false"
        />
      </div>
    </footer>
  );
}
